module.exports = __webpack_public_path__ + "img/girl.f46ae71b.png";